import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { IMAGE_SIZE_CODE } from '../../../../../constants/image-size-codes';
import { getThumbBySize } from '../../../../../util/photo';

const propTypes = {
  position: PropTypes.number.isRequired,
  photo: PropTypes.shape({
    id: PropTypes.string,
    thumbnail_urls: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        size_code: PropTypes.oneOf(Object.values(IMAGE_SIZE_CODE)),
      }),
    ),
  }),
  onEdit: PropTypes.func.isRequired,
};

const CustomPrintPhotoPlaceholder = ({ position, photo, onEdit }) => {
  return (
    <button
      className={classNames({
        'custom-print-photo-placeholder': true,
        'has-photo': !!photo,
      })}
      onClick={() => onEdit(position)}
    >
      <span className="custom-print-photo-placeholder-number">
        {position + 1}
      </span>

      {photo ? (
        <img
          src={getThumbBySize(photo.thumbnail_urls, IMAGE_SIZE_CODE.MEDIUM).url}
          alt=""
          className="custom-print-photo-placeholder-img"
        />
      ) : (
        <span className="custom-print-photo-placeholder-label">
          Press to select a photo
        </span>
      )}
    </button>
  );
};

CustomPrintPhotoPlaceholder.propTypes = propTypes;

export default CustomPrintPhotoPlaceholder;
